import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig';
import { HistPriceVolStreamRequest } from 'widgets/historicalPercentageChange/api/HistPriceVolStreamRequest';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState.ts';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers.ts';
import { initialHistoricalPercentageChangeWidgetConfigState } from 'widgets/historicalPercentageChange/widget/store.ts';

const DefaultPeriodQty = 10;

const toRequestUid = (symbol: string) => `histPriceVol-${symbol}`;

const requestToStreamKey = (request: HistPriceVolStreamRequest) => {
    const { symbol } = request;
    return toRequestUid(symbol);
};
function buildRequest(
    symbol: string,
    symbology: SymbologyValues,
    config: HistoricalPercentageChangeConfig
): HistPriceVolStreamRequest {
    return {
        symbol,
        symbology,
        ndays: config.periodQty ?? DefaultPeriodQty,
    };
}

const {
    buildStreamRequest,
    createWidgetRequestUid,
    getWidgetStreamRequestInfo,
    getStreamRequestInfosForSymbols,
} = buildSymbolDependentRequestHelpers<
    HistPriceVolStreamRequest,
    HistoricalPercentageChangeConfig
>(
    toRequestUid,
    requestToStreamKey,
    buildRequest,
    initialHistoricalPercentageChangeWidgetConfigState
);

export {
    buildStreamRequest as buildHistoricalPercentageChangeStreamRequest,
    createWidgetRequestUid as createHistoricalPercentageChangeRequestUid,
    getWidgetStreamRequestInfo as getHistoricalPercentageChangeStreamRequestInfo,
    getStreamRequestInfosForSymbols as getHistoricalPercentageChangeStreamRequestInfosForSymbols,
    toRequestUid as toHistPriceVolRequestUid,
};
